import { atomFamily } from "recoil";

export const exWxContentsState = atomFamily({
  key: 'exWxContentsState',
  default: {}
});
